"use client";
import styled from "styled-components";
import CompanyCeoImg from "/public/assets/images/company/detail/company-information-ceo.png"
import {SIZES} from "@/components/constants";
import {useContext, useEffect, useRef} from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { LayoutContext } from '@/app/ClientRootHomepage';
import {getScroller, refreshOnAssetsReady, setupLenyStyle} from "@/app/homepage/utils";
import {observer} from "mobx-react";
import {useMediaQuery} from "react-responsive";

gsap.registerPlugin(ScrollTrigger);
gsap.config({ force3D: false });
const Detail = observer(() => {
    const isTablet = useMediaQuery({
        query: `(max-width: ${SIZES.TABLET})`
    });
    const { rootRef } = useContext(LayoutContext);
    const wrapRef = useRef(null);

    useEffect(() => {
        const wrap = wrapRef.current;
        if (!wrap) return;
        const scroller = getScroller(rootRef);
        const contentEl = scroller?.querySelector?.(".root") || scroller?.firstElementChild || scroller;
        const { cleanup } = setupLenyStyle({ wrap, scroller, contentEl });
        const triggers = [];
        const timelines = [];
        const sections = Array.from(wrap.querySelectorAll(".content-wrap"));
        sections.forEach((sec) => {
            const title = sec.querySelector(".content-title");
            const info  = sec.querySelector(".content-info");
            if (!info) return;
            if (title) gsap.set(title, { opacity: 0, willChange: "opacity" });
            gsap.set(info, { y: 30, opacity: 0 });
            const timeLineGsap = gsap.timeline({ paused: true }).to(title || {}, { opacity: 1, duration: 0.4, ease: "power1.out", force3D: false, }, 0).to(info, { y: 0, opacity: 1, duration: 0.6, ease: "power2.out",  force3D: false, }, 0);
            const scrollGsap = ScrollTrigger.create({
                trigger: sec,
                start: "top 70%",
                end:   "top 45%",
                toggleActions: "play none none reverse",
                onEnter: () => { timeLineGsap.play(); info.classList.add("active"); },
                onEnterBack: () => { timeLineGsap.play(); info.classList.add("active"); },
                onLeaveBack: () => { timeLineGsap.reverse(); info.classList.remove("active"); },
            });
            timelines.push(timeLineGsap);
            triggers.push(scrollGsap);
        });
        const offAssets = refreshOnAssetsReady(wrap, () => ScrollTrigger.refresh());
        const onResize = () => ScrollTrigger.refresh();
        window.addEventListener("resize", onResize);
        return () => {
            triggers.forEach((scrollGsap) => scrollGsap.kill());
            timelines.forEach((timeLineGsap) => timeLineGsap.kill());
            window.removeEventListener("resize", onResize);
            offAssets && offAssets();
            cleanup();
        };
    }, [rootRef]);



    // const searchParams = useSearchParams();
    // const menuId = searchParams.get("menu-id");
    // useEffect(() => {
    //     const pageOptions = setFindItemId(navigationStore.navigateList, menuId);
    //     console.log(JSON.stringify(pageOptions))
    // }, [menuId]);
    // const testFetch = async () => {
    //
    //     const url = `${process.env.NEXT_PUBLIC_API_BASE_URL}/api/menu`;
    //     const navi = await safeJsonFetch(url, {cache: "no-store"});
    //     console.log(navi)
    // }

    return(
        <DetailWrap ref={wrapRef}>
            <div className={"content-wrap"}>
                <div className={"content-title"}>
                    {
                        !isTablet ?
                            <>
                                웅비의 시작 면역,<br/>
                                K-Bio를 위한 여정
                            </>
                            :
                            <>
                                웅비의 시작 면역, K-Bio를 위한 여정
                            </>
                    }

                </div>
                <div className={"content-info"}>
                    <p>
                        안녕하십니까?<br/>
                        웅비는 <span>1993년 창업</span> 이래, <span>진단 분야의 새로운 지평</span>을 열고자 노력해왔습니다.
                    </p>
                    {
                        isTablet &&
                        <div className={"video-item-wrap fir"}>
                            <div className={"video-item"}>
                                <iframe
                                    src="https://www.youtube.com/embed/kwRRLa5eaxI?si=kEF1v05UC9z_rdJk"
                                    frameBorder="0"
                                    allowFullScreen
                                ></iframe>
                            </div>
                        </div>
                    }
                    <p>
                        국내에 세계적으로 우수한 면역 및 분자진단 Marker 제품을 소개하며, 진단 기술의 수준을 한 단계 끌어올리는 데 노력해 왔습니다.<br/>
                        그동안 진단 분야에서 축적한 품질관리(QC), 기술력, 경험을 바이오 연구 시장에 접목함으로써 의미 있는 성과를 만들어 왔습니다.<br/><br/>
                        <span>대한민국 바이오 산업 K-Bio가 세계적 위상을 갖추는 데 있어 고객과 함께 힘써왔습니다.</span>
                    </p>

                    <div className={"video-item-wrap"}>
                        {
                            !isTablet &&
                            <div className={"video-item"}>
                                <iframe
                                    src="https://www.youtube.com/embed/kwRRLa5eaxI?si=kEF1v05UC9z_rdJk"
                                    frameBorder="0"
                                    allowFullScreen
                                ></iframe>
                            </div>
                        }
                        <div className={"video-item"}>
                            <iframe
                                src="https://www.youtube.com/embed/LJUOKr_g8Z4?si=YHRK8yk1QrGbgzo6"
                                frameBorder="0"
                                allowFullScreen
                            ></iframe>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"content-wrap"}>
                <div className={"content-title"}>
                {
                        !isTablet ?
                            <>
                                국민 건강을 위한 사명,<br/>
                                그리고 자부심
                            </>
                            :
                            <>
                                국민 건강을 위한 사명, 그리고 자부심
                            </>
                    }
                </div>
                <div className={"content-info"}>
                    <CeoWrap>
                        <p>
                            <span>웅비메디텍</span>은 조기 진단, 조기 치료는 물론, 질환 예방, 정밀진단·치료, 개인 맞춤형 치료, 바이오시밀러 치료제, 세포치료제, 면역 치료제
                            개발 등 각 분야에서 필요로하는 <span>고품질 제품</span>을 공급해 <span>대한민국 국민의 건강을 위한 가치</span>를 만들어가고 있습니다.
                        </p>
                        <div className={"ceo-img"}>
                            <div className={"image-overlay"}></div>
                            <img src={CompanyCeoImg?.src} alt={"ceo 이미지"}/>
                        </div>
                    </CeoWrap>
                    <p>
                        해외의 우수한 제품을 국내에 빠르게 도입함으로써, 국민들이 기타 대리점에 비해 3~5년 앞서 첨단 치료 혜택을 누릴 수 있도록 기여해 온 점은 저희의 큰 자부심 중
                        하나입니다.
                    </p>
                    <p>
                        우리 구성원 모두는 어떤 직무에 있든, <span>“내 일은 내 가족과 대한민국 국민의 생명과 건강을 보호하는 일”</span>이라는 마음가짐으로 임하고 있습니다. 또한,
                        “하나님의 기업으로서 사회에 공헌한다”는 공동 사명 아래, 회사와 개인이 함께 성장해 나가고 있습니다.
                    </p>
                </div>
            </div>
            <div className={"content-wrap"}>
                <div className={"content-title"}>
                    {
                        !isTablet ?
                            <>
                                사람 중심의 성장 철학과<br/>
                                회사 문화
                            </>
                            :
                            <>
                                사람 중심의 성장 철학과 회사 문화
                            </>
                    }
                </div>
                <div className={"content-info"}>
                    <p>
                        웅비의 궁극적인 목표는 고객의 숨겨진 가치를 발굴하고 극대화하는 데 있습니다. 우리는 각자의 개성과 전문성을 존중하며, 단순한 성과보다 '과정'과 '팀워크'를 중시하는 자기
                        주도형 성장 시스템을 운영하고 있습니다.<br/>
                        웅비의 핵심가치는 다음과 같습니다.
                    </p>
                    <StepCont>
                        <div className={"step-inner"}>
                            <div className={"tit"}>첫째,</div>
                            <div className={"cont"}>
                                <div className={"box"}>행복</div>
                                <span>-</span>
                                <p>
                                    내가 행복해야 동료와 회사의 행복으로 연결된다.
                                </p>
                            </div>
                        </div>
                        <div className={"step-inner"}>
                            <div className={"tit"}>둘째,</div>
                            <div className={"cont"}>
                                <div className={"box"}>사람 중심</div>
                                <span>-</span>
                                <p>
                                    모든 판단과 행동의 기준은 '사람'이다
                                </p>
                            </div>
                        </div>
                        <div className={"step-inner"}>
                            <div className={"tit"}>셋째,</div>
                            <div className={"cont"}>
                                <div className={"box"}>지속 동반 성장</div>
                                <span>-</span>
                                <p>
                                    {
                                        !isTablet ?
                                            <>나의 성장은 곧 회사의 성장, 회사의 성장은 곧 나의 성장. 지속되어야 한다.</>
                                            :
                                            <>
                                                나의 성장은 곧 회사의 성장,<br />회사의 성장은 곧 나의 성장.<br/>지속되어야 한다.
                                            </>
                                    }

                                </p>
                            </div>
                        </div>
                    </StepCont>
                    <p>
                        대표이사와 직접 소통하는 ‘웅살롱’, 자기계발과 시대에 맞는 인문학적 소양을 키우는 사내 북클럽이 있으며, 문개위(문화개선위원회)를 운영하여 조직문화의 선진화를 통해
                        무한경쟁의 시장에서 진정한 경쟁력을 만들어가고 있습니다.
                    </p>
                </div>
            </div>
            <div className={"content-wrap"}>
                <div className={"content-title"}>
                    {
                        !isTablet ?
                            <>
                                사회공헌의 실천,<br/>
                                함께하는 가치
                            </>
                            :
                            <>사회공헌의 실천, 함께하는 가치</>
                    }
                </div>
                <div className={"content-info"}>
                    <p>
                        저희는 제품을 통해 국민 건강을 지키는 일을 하는 동시에, 구체적인 사회공헌으로 그 뜻을 확장하고 있습니다.<br/>
                        2017년부터는 이익의 일부를 저소득층·다문화 가정 자녀의 교육에 투자하는 “비투게더edu 프로젝트”를 운영하고 있습니다.<br/>
                        청소년 시기부터 스스로 학습 습관 형성을 위한 공부방 가구 지원은 2025년 7월 기준 659명에게 전달되었습니다.<br/>
                        이들이 미래의 희망으로 성장하여 사회에서 자립할 수 있도록 웅비는 계속해서 함께 걸어가겠습니다.
                    </p>
                    <p>
                        앞으로도 웅비메디텍은 ‘기술의 변화’와 ‘고객의 신뢰’라는 영양제를 먹고 성장할 것입니다. 우수한 제품과 진심 어린 서비스로 고객 가치 실현에 최선을 다하겠습니다.
                    </p>
                    <p className={"dear-desc"}>
                        고객과 함께 진심으로 걷고, 함께 가치를 만들어가는 건강한 기업이 되겠습니다.<br/>
                        고객님, 저희 웅비와 함께 해 주셔서 진심으로 감사합니다.
                    </p>
                    <p className={"dear"}>
                        웅비메디텍 대표이사 이웅섭 드림
                    </p>
                </div>
            </div>
        </DetailWrap>
    )
})
const DetailWrap = styled.div`
    padding: 100px 114px;
    .video-item-wrap{
        display: flex;
        align-items: center;
        gap: 16px;
        margin-top: 32px;
        &.fir{
            margin-bottom: 32px;
        }
        .video-item{
            position:relative;
            width:100%;
            aspect-ratio:16/9;
            iframe{
                width: 100%;
                height: 100%;
                border: 0;
            }
        }
    }
    .content-wrap {
        & + .content-wrap {
            margin-top: 160px;
        }

        display: flex;
        align-items: start;

        .content-title {
            width: 500px;
            flex-shrink: 0;
            font-weight: 700;
            font-size: 48px;
            line-height: 58px;
            letter-spacing: -0.02em;
            color: #4939B1;
        }

        .content-info {
            &.active{
                .image-overlay{
                    transform: translate(0%, -101%);
                    transition: all .6s ease-in-out;
                }
            }
            p {
                font-weight: 400;
                font-size: 20px;
                line-height: 32px;
                color: #000000;

                & + p {
                    margin-top: 32px;
                }

                span {
                    font-weight: 600;
                }
                &.dear-desc{
                    font-weight: 700;
                    font-size: 24px;
                    line-height: 38px;
                }

                &.dear{
                    font-weight: 700;
                    font-size: 32px;
                    line-height: 48px;
                    letter-spacing: -0.02em;
                }
            }
        }
    }
    @media (max-width: ${SIZES.TABLET}) {
       padding: 40px 16px 120px;

        .content-wrap {
            & + .content-wrap {
                margin-top: 80px;
            }
            display: block;
            
            .content-title {
                font-size: 24px;
                line-height: 36px;
                width: auto;
            }

            .content-info {
                margin-top: 40px;
                p {
                    font-size: 16px;
                    line-height: 24px;
                    &.dear-desc{
                        font-size: 16px;
                        line-height: 24px;
                    }

                    &.dear{
                        font-size: 18px;
                        line-height: 28px;
                    }
                }
            }
        }
    }
`
const CeoWrap = styled.div`
    display: flex;
    align-items: end;
    gap: 8px;
    margin-bottom: 32px;

    .ceo-img {
        flex-shrink: 0;
        width: 370px;
        position: relative;
        overflow: hidden;
    }
    @media (max-width: ${SIZES.TABLET}) {
        flex-direction: column;
        gap: 16px;
        .ceo-img {
            width: 100%;
            order: -1;
        }
    }
`
const StepCont = styled.div`
    background: #F2F2F2;
    border-radius: 20px;
    padding: 40px 32px;
    margin: 32px 0;
    .step-inner{
        display: flex;
        align-items: center;
        & + .step-inner{
            margin-top: 24px;
        }
        .tit{
            font-weight: 700;
            font-size: 18px;
            color: #4939B1;
            margin-right: 8px;
            flex-shrink: 0;
        }
        .cont{
            display: flex;
            align-items: center;
            .box{
                flex-shrink: 0;
                font-weight: 700;
                font-size: 18px;
                line-height: 28px;
                color: #FFFFFF;
                background: #4939B1;
                border-radius: 4px;
                padding: 8px 12px;
            }
            span{
                font-weight: 400;
                font-size: 18px;
                color: #BFB4F7;
                margin: 0 10px;
            }
            p{
                font-weight: 700;
                font-size: 18px;
                color: #000000;
            }
        }
    }
    @media (max-width: ${SIZES.TABLET}) {
        padding: 24px 16px;
        .step-inner{
            gap: 4px;
            align-items: start;
            .tit{
                margin: 0;
                font-size: 16px;
                line-height: 40px;
            }
            .cont{
                flex-direction: column;
                align-items: start;
                .box{
                    padding: 8px 12px;
                    font-size: 16px;
                    line-height: 24px;
                }
                span{
                    display: none;
                }
                p{
                    margin-top: 8px;
                    font-weight: 700;
                    font-size: 16px;
                    line-height: 24px;
                }
            }
        }
    }
`
export default Detail;